import React from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ImageIcon from '@mui/icons-material/Image';

export default function ChartExportButton({ containerId }) {
  const { t } = useTranslation();

  const handleExport = () => {
    const container = document.getElementById(containerId);
    if (!container) return;
    const canvas = container.querySelector('canvas');
    if (!canvas) return;

    const link = document.createElement('a');
    link.download = 'finmaple-budget-chart.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
  };

  return (
    <Tooltip title={t('budgetPlanner.charts.exportPng', 'Exportar gráfico como PNG')}>
      <IconButton onClick={handleExport} size="small" sx={{ color: '#1E3A5F', minWidth: 44, minHeight: 44 }} aria-label="Exportar gráfico">
        <ImageIcon />
      </IconButton>
    </Tooltip>
  );
}
